import { heroCover, statusTicker } from "@/mocks/evidence";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-background-50 pt-16 md:pt-[72px]"
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_85%_20%,oklch(var(--accent-100)/0.55),transparent_45%),radial-gradient(circle_at_10%_90%,oklch(var(--primary-100)/0.6),transparent_40%)]" />

      <div className="relative mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-10 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-2 lg:gap-14">
        {/* Left — text */}
        <div className="order-2 lg:order-1">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-700">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-500" />
            持续核验更新中 · 最近更新 今日 09:40
          </span>

          <h2 className="mt-5 font-heading text-3xl font-semibold leading-snug text-foreground-950 md:text-[42px] md:leading-[1.18]">
            想验证八酱黑料真实性？
            <br />
            <span className="text-primary-600">不空谈，只摆实锤证据链。</span>
          </h2>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            本站汇总可查证的
            <strong className="font-semibold text-foreground-900">截图、录音、视频</strong>
            等硬核材料，并对每一处争议点做
            <strong className="font-semibold text-foreground-900">逐项拆解</strong>
            。截图录音视频汇总、石锤材料对照归档，帮你理性判断事件真相。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#library"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
            >
              浏览证据库
              <i className="ri-arrow-right-down-line flex h-4 w-4 items-center justify-center text-base" />
            </a>
            <a
              href="#timeline"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-200/70"
            >
              看石锤拆解时间线
            </a>
          </div>

          <dl className="mt-9 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 sm:grid-cols-4">
            {statusTicker.map((s) => (
              <div key={s.label} className="bg-background-50 px-4 py-3.5">
                <dd className="font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
                  {s.value}
                  <span className="ml-1 text-xs font-medium text-foreground-500">
                    {s.unit}
                  </span>
                </dd>
                <dt className="mt-1 text-xs text-foreground-600">{s.label}</dt>
              </div>
            ))}
          </dl>
        </div>

        {/* Right — image */}
        <div className="order-1 lg:order-2">
          <div className="relative">
            <div className="absolute -inset-2 -z-0 translate-x-3 translate-y-3 bg-accent-100" />
            <div className="relative overflow-hidden rounded-lg bg-primary-950">
              <img
                src={heroCover}
                alt="八酱黑料实锤证据档案封面"
                title="八酱黑料 实锤证据挖掘"
                className="h-[320px] w-full object-cover object-top sm:h-[420px] lg:h-[500px]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-black/10" />
              <div className="absolute inset-x-0 bottom-0 flex items-center justify-between gap-3 p-4 md:p-5">
                <span className="inline-flex items-center gap-2 rounded-md bg-background-50/90 px-3 py-1.5 text-xs font-semibold text-foreground-900 backdrop-blur">
                  <i className="ri-folder-check-line flex h-4 w-4 items-center justify-center text-primary-600" />
                  Evidence Dossier · Vol.07
                </span>
                <span className="inline-flex items-center gap-2 rounded-md bg-primary-600 px-3 py-1.5 text-xs font-semibold text-background-50">
                  <i className="ri-vidicon-line flex h-4 w-4 items-center justify-center text-sm" />
                  封面检索
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}